import { SetToken }                     from './AuthHelpers'
import { OpenAppointmentsModal, 
         RepositionModalOnResize,
         RepositionModal }              from './ModalHelpers'
import { ShowProgress, HideProgress }   from './LoaderHelpers'
import { SundayDate, 
         IsToday,
         IsSelected,
         IsAvailable,
         AvailableDay,
         AddDaysToDate, 
         LastDayOfMonth, 
         FirstDayOfMonth, 
         GetCalendarDays, 
         GetCalendarWeeks, 
         CreateDateString, 
         StartBookingTimer,
         timeFromDisplayTime,
         timeFromMilitaryTime,
         ampmFromDisplayTime,
         GetFirstCalendarDate }         from './DateHelpers'
import { ParseInt,
         ParseDate,
         FormatTime,
         SplitFullName,
         FormatDuration,
         FormatImageData,
         ParsePhoneNumber,
         FormatFormFields,
         FormatPhoneNumber,
         FormatServiceDescription,
         FormatServiceDuration,
         ToLocaleISOString,
         FormatRescheduleByDateSpan,
         FormatShortTimeZoneOffset }    from './FormatHelpers'
import { IsEmpty,
         IsNotEmpty,
         GetFunctionName,
         GetUrlParameter,
         CreateAvailabilityUrl,
         AddUrlParam,
         DataValue,
         CheckboxChecked,
         GetFormElementDataValue,
         Tooltips }                     from './IdentifierHelpers'
import { TemplateParameters,
         CustomTemplateParameters,
         ReplaceParameterValues }       from './ParameterHelpers'
import { ThrowError, ReformatErrorMsg } from './ErrorHelpers'
import { CustomEventContent,
         CalendarEventClassNames,
         CalendarLoading,
         CalendarViews,
         ServiceSelectedInfo,
         CalendarReasonCodes,
         HeaderToolbar,
         GetCalendarPostion,
         GetResourceBusinessHours,
         GetAmalgamatedResourceBusinessHours,
         GetMultiResourceData }         from './CalendarHelpers'
import { ViewAppointmentForm }          from './FormHelpers'
import { CurrentTheme,
         CalendarPopupStylesheet }      from './InjectedStylesheets'
import { AddToast }                     from './ToastHelpers'
import { multiselectdropdown }          from './multiselect-dropdown'
import { CalendarCustomEvents,
         UtilityCustomEvents }          from './CustomEventHelpers'
import { TriggerAfterTyping }           from './InputHelpers'


export const OnSchedHelpers = {
  SundayDate,
  IsToday,
  IsAvailable,
  IsSelected,
  AvailableDay,
  IsEmpty,
  IsNotEmpty,
  GetFunctionName,
  GetUrlParameter,
  CreateAvailabilityUrl,
  AddUrlParam,
  GetFormElementDataValue,
  CreateDateString,
  GetFirstCalendarDate,
  GetCalendarDays,
  GetCalendarWeeks,
  FirstDayOfMonth,
  LastDayOfMonth,
  AddDaysToDate,
  ShowProgress,
  HideProgress,
  ParseDate,
  ParseInt,
  FormatServiceDescription,
  FormatServiceDuration,
  FormatTime,
  FormatDuration,
  FormatPhoneNumber,
  ParsePhoneNumber,
  StartBookingTimer,
  SetToken,
  OpenAppointmentsModal,
  timeFromMilitaryTime,
  timeFromDisplayTime,
  ampmFromDisplayTime,
  DataValue,
  CheckboxChecked,
  TemplateParameters,
  CustomTemplateParameters,
  FormatImageData,
  RepositionModal,
  RepositionModalOnResize,
  ThrowError,
  ReplaceParameterValues,
  CustomEventContent,
  CalendarEventClassNames,
  CalendarLoading,
  CalendarViews,
  CalendarReasonCodes,
  HeaderToolbar,
  FormatFormFields,
  ViewAppointmentForm,
  CalendarPopupStylesheet,
  CurrentTheme,
  Tooltips,
  ToLocaleISOString,
  AddToast,
  FormatRescheduleByDateSpan,
  multiselectdropdown,
  ServiceSelectedInfo,
  SplitFullName,
  CalendarCustomEvents,
  UtilityCustomEvents,
  GetCalendarPostion,
  TriggerAfterTyping,
  FormatShortTimeZoneOffset,
  ReformatErrorMsg,
  GetMultiResourceData,
  GetResourceBusinessHours,
  GetAmalgamatedResourceBusinessHours,
}
